/*
 * @Author: Merlin
 * @Date: 2024-03-11 09:59:26
 * @LastEditors: Gaho
 * @LastEditTime: 2024-11-26 15:50:04
 * @Description: 
 */

// 用于 spaceDice 游戏 
export const startCountingAnimate = (
    startNumber:number,
    targetNumber:number,
    duration:number,
    animatedNumber, // 一个 ref() 对象 
    callback=(()=>void 0), // 执行完毕后将调用此方法 
) => {
    let startTime;

    const updateNumber = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const progress = (currentTime - startTime) / duration;

        if (startNumber < targetNumber) {
            // Increase case
            animatedNumber.value = Math.min(
                Math.floor(progress * (targetNumber - startNumber)) + startNumber,
                targetNumber,
            );
        } else {
            // Decrease case
            animatedNumber.value = Math.max(
                Math.floor(progress * (targetNumber - startNumber)) + startNumber,
                targetNumber,
            );
        }

        if (progress < 1) {
            requestAnimationFrame(updateNumber);
        } else {
            callback();
        }
    };
    requestAnimationFrame(updateNumber);
};

// 用于 dice 游戏
// 结果值的原版说明：Random number generator will choose the winning number from 0 to 99
export const numberIncreasingAnimate = (
    startNumber:number,
    targetNumber:number,
    duration:number, // 动画总耗时 ms
    animatedNumber, // 一个 ref() 对象 
    callback=(()=>void 0), // 执行完毕后将调用此方法 
) => {
    let startTime = 0;
    const [min, max] = [0, 99];
    const arr01 = [...Array(100).keys()].map(cur=> {
        return String(cur).padStart(2, '0');
    });
    const iDistance = (max - startNumber) + (targetNumber - min) + 2;
    const aMiddile = (
        iDistance <= 60
        && arr01.filter(cur=> Number(cur) / 2)
    );
    let arr02 = arr01.slice(startNumber);
    if (aMiddile){
        arr02.push(...aMiddile);
    }
    arr02.push(...arr01.slice(0, targetNumber + 1));
    const iAllSteps = arr02.length - 1; 
    // console.log(`iDistance: ${startNumber}-${targetNumber} =>`, iDistance); 
    // console.log("计划：", `${0}-${iAllSteps}`);  
    const updateNumber = (currentTime) => {
        startTime ||= currentTime;
        const fProgress = (currentTime - startTime) / (duration * 1);
        const index = Math.min(
            iAllSteps,
            Math.round(iAllSteps * fProgress),
        );
        // console.log("当前位置", `${index}/${iAllSteps}`); 
        animatedNumber.value = arr02[index];
        if (fProgress < 1) {
            requestAnimationFrame(updateNumber);
        } else {
            animatedNumber.value = targetNumber;
            callback();
        }
    };
    requestAnimationFrame(updateNumber);
};



// ↓ 绘制（刷新） canvas 画布的方法 
export const fnCanvasAnimationRunner = (
    oInstance, // 类实例
    fnAfterRedraw=()=>{} // 可选方法
)=>{
    const c = 33.333333333333336;
    let iLastDrawnAt = Date.now(); // 上次绘制时间
    let a = 0;
    const dev = import.meta.dev;
    let oError = null;
    const fnRepeater = ()=>{
        if (!oInstance.live) {
            return (dev && console.log('已经关停动画 01'));
        }else if (dev && oError){
            return (dev && console.log('已经关停动画 01 oError\n', oError));
        }
        const iThisCrawAt = Date.now(); // 本次绘制时间
        const iGap = iThisCrawAt - iLastDrawnAt; // 2次绘制的间距
        for (iLastDrawnAt = iThisCrawAt, a += iGap; a >= c; ){
            oInstance.update();
            a -= c;
        }
        if (!oInstance.live) {
            return (dev && console.log('已经关停动画 02'));
        }
        iLastDrawnAt = Date.now();
        window.requestAnimationFrame(fnRepeater);
        try{
            oInstance.redraw();
            fnAfterRedraw();
        }catch(err){
            oError = err;
        }
    };
    window.requestAnimationFrame(fnRepeater);
}
